import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import {UserBlockedService} from "../../lib/services/user-blocked/user-blocked-service.service";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";

@Component({
  selector: 'lib-user-blocked-modal',
  templateUrl: './user-blocked-modal.component.html',
  styleUrls: ['./user-blocked-modal.component.scss']
})
export class UserBlockedModalComponent {
  translations: any

  constructor(
    public translate: TranslateService,
    private router: Router,
    private userBlockedService: UserBlockedService,
    private autheticationService: AuthenticationService
  ) { }

  closeDialog() {
    this.autheticationService.logOut()
    this.userBlockedService.close()
    location.reload()
  }
}
